export class LinkServiceCenterRegionsRequest {
    oSMRegionIdToLink: number[] = [];
}